import { GeographyTypesEnum } from '../enum/geography-types.enum';

export class GetChildRegionModel {
    geographyType: GeographyTypesEnum;
    parentType?: GeographyTypesEnum;
    parentId?: number;
}
